import React from "react";
import { Tab } from "material-ui";

import ConfiguratorItem from "./configurator-item.jsx";

class ConfiguratorSection extends React.Component {
  getStyles() {
    return {
      wrapper: {
        padding: "15px 15px 30px"
      },
      fullWidthWrapper: {
        padding: 30
      },
      description: {
        fontSize: 12,
        marginBottom: 15
      }
    };
  }

  render() {
    let styles = this.getStyles(),
      { schema, config, isFullWidth, isGod, isEnterprise } = this.props;

    return (
      <div
        style={Object.assign(
          styles.wrapper,
          isFullWidth && styles.fullWidthWrapper
        )}
      >
        <div style={styles.description}>{schema.description}</div>
        {schema.items.map(item => {
          return (
            <ConfiguratorItem
              key={item.key}
              eventBucket={this.props.eventBucket}
              item={item}
              config={config}
              isFullWidth={isFullWidth}
              onConfigChange={this.props.onConfigChange}
              onConfigFocus={this.props.onConfigFocus}
              onConfigBlur={this.props.onConfigBlur}
              onForcePreview={this.props.onForcePreview}
              onEndForcePreview={this.props.onEndForcePreview}
              isGod={isGod}
              isEnterprise={isEnterprise}
            />
          );
        })}
      </div>
    );
  }
}

export default ConfiguratorSection;



// WEBPACK FOOTER //
// ./src/app/components/partials/configurator/configurator-section.jsx